// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ourmembers[data-v-74a7dc50] {\n  min-height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
